export const createRequestForCreation = (
  selectedDocuments: any[],
  editingRequest: any,
  requestConfiguration: any,
  productType: string,
  operationDateDate: Date,
) => {
  console.log('PreselectedDocuments', selectedDocuments);
  const documentsForRequest = selectedDocuments.map((document: any) => {
    const date =
      typeof document.paymentDate === 'string'
        ? new Date(document.paymentDate)
        : document.paymentDate;
    return {
      id: document.id,
      amount: document.amount,
      amountDocument: 0,
      amountFinanced: 0,
      amountRetention: 0,
      businessIdentifier: document.businessIdentifier,
      businessName: document.businessName,
      issuer: document.issuer,
      issuedDate: document.issuedDate,
      issuedDateShortString: document.issuedDate.split('T')[0],
      daysToCount: document.daysToCount,
      confirmDate: document.confirmDate,
      cedded: 'No cedido',
      folio: document.folio,
      paymentDate: date,
      paymentDateString: date.toISOString(),
      paymentDateShortString: date.toISOString().split('T')[0],
      subProductName: undefined, // TODO: ?
      cancelDate: document.cancelDate,
      stakeholderName: document.stakeholderName,
      stakeholderIdentifier: document.stakeholderIdentifier,
      active: true,
      code: document.code,
      userOwnerId: document.executive,    
    };
  });

  const documents = documentsForRequest.flat();

  let request;
  if (editingRequest) {
    request = {
      id: editingRequest.id,
      advance: 100,
      rate: editingRequest.rate,
      arrearType: editingRequest.arrearType,
      arrearRate: editingRequest.arrearRate,
      arrearTableId: editingRequest.arrearTableId,
      expensesHasIVA: requestConfiguration.expensesHasIVA || false,
      stakeholderIdentifier: editingRequest.stakeholderIdentifier,
      stakeholderName: editingRequest.stakeholderName,
      amount: documents.reduce((acc: any, curr: any) => acc + curr.amount, 0),
      subProduct: 'electronic-invoice-confirming', // TODO: HARDCODED
      subProductName: 'Factura electrónica confirming', // TODO: HARDCODED
      productType: editingRequest.type,
      documents: documents,
      requestDate: operationDateDate.toISOString(),
      operationCostComissionFixed: editingRequest.operationCostFixed,
      operationCostVariable: editingRequest.operationCostVariable,
      operationCostComissionVariablePercentage:
        editingRequest.operationCostVariablePercentage,
      expensesCost: editingRequest.expensesCost,
      userOwnerId: editingRequest.executive ,
    };
  } else {
    request = {
      id: null,
      advance: 100,
      rate: 0,
      arrearType: 'lineal',
      arrearRate: requestConfiguration.arrearRate,
      arrearTableId: null,
      expensesHasIva: requestConfiguration.expensesHasIVA || false,
      stakeholderIdentifier: documents[0].stakeholderIdentifier,
      stakeholderName: documents[0].stakeholderName,
      amount: documents.reduce((acc: any, curr: any) => acc + curr.amount, 0),
      subProduct: 'electronic-invoice-confirming', // TODO: HARDCODED
      subProductName: 'Factura electrónica confirming', // TODO: HARDCODED
      productType: productType,
      documents: documents,
      requestDate: operationDateDate.toISOString(),
      userOwnerId: documents[0].userOwnerId,
    };
  }
  return request;
};
